<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">BIS-11</h3>
    </div>
</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<div *ngIf="!started" class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>
                <div class="col-12">
                    <button class="btn waves-effect btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>
                    <button type="button" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>

                </div>
            </div>
        </div>
    </div>
</div>

    <div *ngIf="started" class="row justify-content-center">

        <div class="col-md-10">
            <div class="card p-20">
                <div class="card-body">
                   <div>
                        <div class="row">
                            <div *ngFor="let question of questions; index as i" class="col-md-6 m-t-20">
                                <div class="col-md-12">
                                    <h5 class="text-info"><b>{{i+1}} - {{question.title}}</b></h5>
                                    <div>
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio1" [name]="i" value="A"  [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Raramente o nunca</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div >
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio2" [name]="i" value="B" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Ocasionalmente</span>
                                            </label>
                                        </div>
    
                                    </div>
                                    <div >
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio3" [name]="i" value="C" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">A menudo</span>
                                            </label>
                                        </div>
        
                                    </div>
                                    <div >
                                        <div class="form-check">
                                            <label class="custom-control custom-radio">
                                                <input id="radio4" [name]="i" value="D" [(ngModel)]="selected[i]" type="radio" class="custom-control-input">
                                                <span class="custom-control-indicator"></span>
                                                <span class="custom-control-description">Siempre o casi siempre</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <button class="btn btn-success btn-rounded waves-effect pull-right" (click)="nextSerie()">Finalizar test</button>
                        </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
